import { User_Roles_Enum } from "src/state/gql/_types"

export function getMappedUserRoleAdmin (theRole: User_Roles_Enum): string {

    const adminRoles: { [index in User_Roles_Enum]: string } = {
        [User_Roles_Enum.Administrator]: "Admin",
        [User_Roles_Enum.AgencyAccountingAdministrator]: "Agency Accounting Admin",
        [User_Roles_Enum.AgencyAccountingUser]: "Agency Accounting User",
        [User_Roles_Enum.AgencyBookerAdministrator]: "Agency Booker Admin",
        [User_Roles_Enum.AgencyBookerUser]: "Agency Booker User",
        [User_Roles_Enum.AgencyDoorAdministrator]: "Agency Door Admin",
        [User_Roles_Enum.AgencyDoorUser]: "Agency Door User",
        [User_Roles_Enum.AgencyMarketingAdministrator]: "Agency Marketing Admin",
        [User_Roles_Enum.AgencyMarketingUser]: "Agency Marketing User",
        [User_Roles_Enum.AgencyOperationsAdministrator]: "Agency Operations Admin",
        [User_Roles_Enum.AgencyOperationsUser]: "Agency Operations User",
        [User_Roles_Enum.AgencyTalentAdministrator]: "Agency Talent Admin",
        [User_Roles_Enum.AgencyTalentUser]: "Agency Talent User",
        [User_Roles_Enum.Guest]: "Guest",
        [User_Roles_Enum.Superadmin]: "SuperAdmin",
        [User_Roles_Enum.User]: "User",
        [User_Roles_Enum.VenueAccountingAdministrator]: "Venue Accounting Admin",
        [User_Roles_Enum.VenueAccountingUser]: "Venue Accounting User",
        [User_Roles_Enum.VenueBookerAdministrator]: "Venue Booker Admin",
        [User_Roles_Enum.VenueBookerUser]: "Venue Booker User",
        [User_Roles_Enum.VenueDoorAdministrator]: "Venue Door Admin",
        [User_Roles_Enum.VenueDoorUser]: "Venue Door User",
        [User_Roles_Enum.VenueMarketingAdministrator]: "Venue Marketing Admin",
        [User_Roles_Enum.VenueMarketingUser]: "Venue Marketing User",
        [User_Roles_Enum.VenueOperationsAdministrator]: "Venue Operations Admin",
        [User_Roles_Enum.VenueOperationsUser]: "Venue Operations User",
        [User_Roles_Enum.VenueTalentAdministrator]: "Venue Talent Admin",
        [User_Roles_Enum.VenueTalentUser]: "Venue Talent User",
    }

    return adminRoles[theRole]

}

export function getMappedUserRoleTenant(theRole: User_Roles_Enum): string {

    const tenantRoles: { [index in User_Roles_Enum]: string } = {
        [User_Roles_Enum.Administrator]: "Administrator",
        [User_Roles_Enum.AgencyAccountingAdministrator]: "Agency Accounting Admin",
        [User_Roles_Enum.AgencyAccountingUser]: "Agency Accounting User",
        [User_Roles_Enum.AgencyBookerAdministrator]: "Agency Booker Admin",
        [User_Roles_Enum.AgencyBookerUser]: "Agency Booker User",
        [User_Roles_Enum.AgencyDoorAdministrator]: "Agency Door Admin",
        [User_Roles_Enum.AgencyDoorUser]: "Agency Door User",
        [User_Roles_Enum.AgencyMarketingAdministrator]: "Agency Marketing Admin",
        [User_Roles_Enum.AgencyMarketingUser]: "Agency Marketing User",
        [User_Roles_Enum.AgencyOperationsAdministrator]: "Agency Operations Admin",
        [User_Roles_Enum.AgencyOperationsUser]: "Agency Operations User",
        [User_Roles_Enum.AgencyTalentAdministrator]: "Agency Talent Admin",
        [User_Roles_Enum.AgencyTalentUser]: "Agency Talent User",
        [User_Roles_Enum.Guest]: "Guest",
        [User_Roles_Enum.Superadmin]: "SuperAdmin",
        [User_Roles_Enum.User]: "User",
        [User_Roles_Enum.VenueAccountingAdministrator]: "Venue Accounting Admin",
        [User_Roles_Enum.VenueAccountingUser]: "Venue Accounting User",
        [User_Roles_Enum.VenueBookerAdministrator]: "Venue Booker Admin",
        [User_Roles_Enum.VenueBookerUser]: "Venue Booker User",
        [User_Roles_Enum.VenueDoorAdministrator]: "Venue Door Admin",
        [User_Roles_Enum.VenueDoorUser]: "Venue Door User",
        [User_Roles_Enum.VenueMarketingAdministrator]: "Venue Marketing Admin",
        [User_Roles_Enum.VenueMarketingUser]: "Venue Marketing User",
        [User_Roles_Enum.VenueOperationsAdministrator]: "Venue Operations Admin",
        [User_Roles_Enum.VenueOperationsUser]: "Venue Operations User",
        [User_Roles_Enum.VenueTalentAdministrator]: "Venue Talent Admin",
        [User_Roles_Enum.VenueTalentUser]: "Venue Talent User",
    }

    return tenantRoles[theRole]

}